import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Contact } from './components/Contact';
import { AutoRepairServicesPage } from './components/pages/AutoRepairServices';
import { TruckRepairServicesPage } from './components/pages/TruckRepairServices';
import { DieselEngineRepairPage } from './components/pages/DieselEngineRepair';
import { DriveShaftRepairPage } from './components/pages/DriveShaftRepair';
import { FleetMaintenancePage } from './components/pages/FleetMaintenance';
import { BasicMaintenancePage } from './components/pages/BasicMaintenance';
import { TeslaCybertruckPage } from './components/pages/TeslaCybertruck';
import { Ford73LGasPage } from './components/pages/Ford73LGas';
import { PowerStrokePage } from './components/pages/PowerStroke';
import { PowerStroke60LPage } from './components/pages/PowerStroke60L';
import { PowerStroke64LPage } from './components/pages/PowerStroke64L';
import { PowerStroke73LPage } from './components/pages/PowerStroke73L';
import { IsuzuRepairPage } from './components/pages/IsuzuRepair';
import { MediumDutyPage } from './components/pages/MediumDuty';
import { ProfessionalWitnessPage } from './components/pages/ProfessionalWitness';
// Auto Repair Pages
import { AutomotiveTuneUp } from './components/pages/auto-repair/AutomotiveTuneUp';
import { AutoCoolingSystem } from './components/pages/auto-repair/AutoCoolingSystem';
import { BrakeRepair } from './components/pages/auto-repair/BrakeRepair';
import { EngineRepair } from './components/pages/auto-repair/EngineRepair';
import { SteeringSuspension } from './components/pages/auto-repair/SteeringSuspension';
import { TiresWheels } from './components/pages/auto-repair/TiresWheels';
import { FuelInjection } from './components/pages/auto-repair/FuelInjection';
import { AutoMythsDebunked } from './components/pages/auto-repair/AutoMythsDebunked';
import { FuelSavings } from './components/pages/auto-repair/FuelSavings';
import { AutoRepairMechanicPage } from './components/pages/auto-repair/AutoRepairMechanic';
// Fleet Pages
import { FleetServicePage } from './components/pages/fleet/FleetService';
// Commercial Pages
import { FreightBoxRepairPage } from './components/pages/commercial/FreightBoxRepair';
import { LiftgateInfoPage } from './components/pages/commercial/LiftgateInfo';
import { RollUpDoorServicePage } from './components/pages/commercial/RollUpDoorService';
import { RollUpDoorPartsPage } from './components/pages/commercial/RollUpDoorParts';
import { EquipmentRepaintingPage } from './components/pages/commercial/EquipmentRepainting';
// Partner Pages
import { HorseTrailerRepairPage } from './components/pages/partner/HorseTrailerRepair';
import { TrailerRepairPage } from './components/pages/partner/TrailerRepair';
import { TrailerHitchInfoPage } from './components/pages/partner/TrailerHitchInfo';
import { TravelTrailerRepairPage } from './components/pages/partner/TravelTrailerRepair';
import { MotorHomeRepairPage } from './components/pages/partner/MotorHomeRepair';
import { FarmEquipmentRepairPage } from './components/pages/partner/FarmEquipmentRepair';
// DOT Pages
import { DotForLifePage } from './components/pages/dot/DotForLife';
import { MichiganDotInspectionPage } from './components/pages/dot/MichiganDotInspection';
import { DotInspectionPage } from './components/pages/dot/DotInspection';
import { DotNumberPage } from './components/pages/dot/DotNumber';
import { CargoSecurementRulesPage } from './components/pages/dot/CargoSecurementRules';
import { VehicleInspectionAidPage } from './components/pages/dot/VehicleInspectionAid';
// CDL Pages
import { CdlTypesPage } from './components/pages/cdl/CdlTypes';
import { CdlDoINeedOnePage } from './components/pages/cdl/CdlDoINeedOne';
import { CdlTestingInfoPage } from './components/pages/cdl/CdlTestingInfo';
import { HoursOfServicePage } from './components/pages/cdl/HoursOfService';
import { MedicalCardInfoPage } from './components/pages/cdl/MedicalCardInfo';
import { GvwPage } from './components/pages/cdl/GvwPage';
import { VehicleLoadSizePage } from './components/pages/cdl/VehicleLoadSize';
import { OverSizedLoadPage } from './components/pages/cdl/OverSizedLoad';
import { InterstateOperatingAuthorityPage } from './components/pages/cdl/InterstateOperatingAuthority';
import { RegistrationLicensingFormsPage } from './components/pages/cdl/RegistrationLicensingForms';
import { TrafficViolationConvictionsPage } from './components/pages/cdl/TrafficViolationConvictions';
import { WhatElseDoINeedToKnowPage } from './components/pages/cdl/WhatElseDoINeedToKnow';
export function AppRouter() {
  return <BrowserRouter data-id="element-11">
      <Routes data-id="element-12">
        <Route path="/" element={<App data-id="element-14" />} data-id="element-13" />

        <Route path="/contact" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-16">
              <Header data-id="element-17" />
              <main className="flex-grow" data-id="element-18">
                <Contact data-id="element-19" />
              </main>
              <Footer data-id="element-20" />
            </div>} data-id="element-15" />

        {/* Auto Repair Pages */}
        <Route path="/auto-repair-mechanic.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-22">
              <Header data-id="element-23" />
              <main className="flex-grow" data-id="element-24">
                <AutoRepairMechanicPage data-id="element-25" />
              </main>
              <Footer data-id="element-26" />
            </div>} data-id="element-21" />

        <Route path="/BasicCarandTruckMaintenance.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-28">
              <Header data-id="element-29" />
              <main className="flex-grow" data-id="element-30">
                <BasicMaintenancePage data-id="element-31" />
              </main>
              <Footer data-id="element-32" />
            </div>} data-id="element-27" />

        <Route path="/auto-repair/tune-up" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-34">
              <Header data-id="element-35" />
              <main className="flex-grow" data-id="element-36">
                <AutomotiveTuneUp data-id="element-37" />
              </main>
              <Footer data-id="element-38" />
            </div>} data-id="element-33" />

        <Route path="/auto-repair/cooling-system" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-40">
              <Header data-id="element-41" />
              <main className="flex-grow" data-id="element-42">
                <AutoCoolingSystem data-id="element-43" />
              </main>
              <Footer data-id="element-44" />
            </div>} data-id="element-39" />

        <Route path="/auto-repair/brake-repair" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-46">
              <Header data-id="element-47" />
              <main className="flex-grow" data-id="element-48">
                <BrakeRepair data-id="element-49" />
              </main>
              <Footer data-id="element-50" />
            </div>} data-id="element-45" />

        <Route path="/auto-repair/engine-repair" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-52">
              <Header data-id="element-53" />
              <main className="flex-grow" data-id="element-54">
                <EngineRepair data-id="element-55" />
              </main>
              <Footer data-id="element-56" />
            </div>} data-id="element-51" />

        <Route path="/auto-repair/steering-suspension" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-58">
              <Header data-id="element-59" />
              <main className="flex-grow" data-id="element-60">
                <SteeringSuspension data-id="element-61" />
              </main>
              <Footer data-id="element-62" />
            </div>} data-id="element-57" />

        <Route path="/auto-repair/tires-wheels" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-64">
              <Header data-id="element-65" />
              <main className="flex-grow" data-id="element-66">
                <TiresWheels data-id="element-67" />
              </main>
              <Footer data-id="element-68" />
            </div>} data-id="element-63" />

        <Route path="/auto-repair/fuel-injection" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-70">
              <Header data-id="element-71" />
              <main className="flex-grow" data-id="element-72">
                <FuelInjection data-id="element-73" />
              </main>
              <Footer data-id="element-74" />
            </div>} data-id="element-69" />

        <Route path="/auto-repair/auto-myths" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-76">
              <Header data-id="element-77" />
              <main className="flex-grow" data-id="element-78">
                <AutoMythsDebunked data-id="element-79" />
              </main>
              <Footer data-id="element-80" />
            </div>} data-id="element-75" />

        <Route path="/auto-repair/fuel-savings" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-82">
              <Header data-id="element-83" />
              <main className="flex-grow" data-id="element-84">
                <FuelSavings data-id="element-85" />
              </main>
              <Footer data-id="element-86" />
            </div>} data-id="element-81" />

        {/* Service Pages */}
        <Route path="/TeslaCyberTruckMaintenance" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-88">
              <Header data-id="element-89" />
              <main className="flex-grow" data-id="element-90">
                <TeslaCybertruckPage data-id="element-91" />
              </main>
              <Footer data-id="element-92" />
            </div>} data-id="element-87" />

        {/* Fleet Services */}
        <Route path="/diesel-fleet-service.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-94">
              <Header data-id="element-95" />
              <main className="flex-grow" data-id="element-96">
                <FleetServicePage data-id="element-97" />
              </main>
              <Footer data-id="element-98" />
            </div>} data-id="element-93" />

        <Route path="/services/fleet-maintenance" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-100">
              <Header data-id="element-101" />
              <main className="flex-grow" data-id="element-102">
                <FleetMaintenancePage data-id="element-103" />
              </main>
              <Footer data-id="element-104" />
            </div>} data-id="element-99" />

        {/* Diesel & Fleet Pages */}
        <Route path="/dieselenginerepair.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-106">
              <Header data-id="element-107" />
              <main className="flex-grow" data-id="element-108">
                <DieselEngineRepairPage data-id="element-109" />
              </main>
              <Footer data-id="element-110" />
            </div>} data-id="element-105" />

        <Route path="/powerstrokerepair.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-112">
              <Header data-id="element-113" />
              <main className="flex-grow" data-id="element-114">
                <PowerStrokePage data-id="element-115" />
              </main>
              <Footer data-id="element-116" />
            </div>} data-id="element-111" />

        <Route path="/6_0lpowerstrokerepair.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-118">
              <Header data-id="element-119" />
              <main className="flex-grow" data-id="element-120">
                <PowerStroke60LPage data-id="element-121" />
              </main>
              <Footer data-id="element-122" />
            </div>} data-id="element-117" />

        <Route path="/6_4lpowerstrokerepair.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-124">
              <Header data-id="element-125" />
              <main className="flex-grow" data-id="element-126">
                <PowerStroke64LPage data-id="element-127" />
              </main>
              <Footer data-id="element-128" />
            </div>} data-id="element-123" />

        <Route path="/7_3lpowerstrokerepair.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-130">
              <Header data-id="element-131" />
              <main className="flex-grow" data-id="element-132">
                <PowerStroke73LPage data-id="element-133" />
              </main>
              <Footer data-id="element-134" />
            </div>} data-id="element-129" />

        <Route path="/Ford-7.3L-Gas-Engine-Problems" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-136">
              <Header data-id="element-137" />
              <main className="flex-grow" data-id="element-138">
                <Ford73LGasPage data-id="element-139" />
              </main>
              <Footer data-id="element-140" />
            </div>} data-id="element-135" />

        <Route path="/isuzu-truck-repair-near-me" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-142">
              <Header data-id="element-143" />
              <main className="flex-grow" data-id="element-144">
                <IsuzuRepairPage data-id="element-145" />
              </main>
              <Footer data-id="element-146" />
            </div>} data-id="element-141" />

        <Route path="/driveshaftrepair.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-148">
              <Header data-id="element-149" />
              <main className="flex-grow" data-id="element-150">
                <DriveShaftRepairPage data-id="element-151" />
              </main>
              <Footer data-id="element-152" />
            </div>} data-id="element-147" />

        {/* Commercial / Work Truck Pages */}
        <Route path="/commercial/freight-box-repair" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-154">
              <Header data-id="element-155" />
              <main className="flex-grow" data-id="element-156">
                <FreightBoxRepairPage data-id="element-157" />
              </main>
              <Footer data-id="element-158" />
            </div>} data-id="element-153" />

        <Route path="/commercial/liftgate-info" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-160">
              <Header data-id="element-161" />
              <main className="flex-grow" data-id="element-162">
                <LiftgateInfoPage data-id="element-163" />
              </main>
              <Footer data-id="element-164" />
            </div>} data-id="element-159" />

        <Route path="/commercial/roll-up-door-service" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-166">
              <Header data-id="element-167" />
              <main className="flex-grow" data-id="element-168">
                <RollUpDoorServicePage data-id="element-169" />
              </main>
              <Footer data-id="element-170" />
            </div>} data-id="element-165" />

        <Route path="/commercial/roll-up-door-parts" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-172">
              <Header data-id="element-173" />
              <main className="flex-grow" data-id="element-174">
                <RollUpDoorPartsPage data-id="element-175" />
              </main>
              <Footer data-id="element-176" />
            </div>} data-id="element-171" />

        <Route path="/commercial/equipment-repainting" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-178">
              <Header data-id="element-179" />
              <main className="flex-grow" data-id="element-180">
                <EquipmentRepaintingPage data-id="element-181" />
              </main>
              <Footer data-id="element-182" />
            </div>} data-id="element-177" />

        {/* Partner Services Pages */}
        <Route path="/Horse-Trailer-Repair" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-184">
              <Header data-id="element-185" />
              <main className="flex-grow" data-id="element-186">
                <HorseTrailerRepairPage data-id="element-187" />
              </main>
              <Footer data-id="element-188" />
            </div>} data-id="element-183" />

        <Route path="/Trailer-Repair" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-190">
              <Header data-id="element-191" />
              <main className="flex-grow" data-id="element-192">
                <TrailerRepairPage data-id="element-193" />
              </main>
              <Footer data-id="element-194" />
            </div>} data-id="element-189" />

        <Route path="/partner/trailer-hitch-info" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-196">
              <Header data-id="element-197" />
              <main className="flex-grow" data-id="element-198">
                <TrailerHitchInfoPage data-id="element-199" />
              </main>
              <Footer data-id="element-200" />
            </div>} data-id="element-195" />

        <Route path="/partner/travel-trailer-repair" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-202">
              <Header data-id="element-203" />
              <main className="flex-grow" data-id="element-204">
                <TravelTrailerRepairPage data-id="element-205" />
              </main>
              <Footer data-id="element-206" />
            </div>} data-id="element-201" />

        <Route path="/motor-home-repair.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-208">
              <Header data-id="element-209" />
              <main className="flex-grow" data-id="element-210">
                <MotorHomeRepairPage data-id="element-211" />
              </main>
              <Footer data-id="element-212" />
            </div>} data-id="element-207" />

        <Route path="/partner/farm-equipment-repair" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-214">
              <Header data-id="element-215" />
              <main className="flex-grow" data-id="element-216">
                <FarmEquipmentRepairPage data-id="element-217" />
              </main>
              <Footer data-id="element-218" />
            </div>} data-id="element-213" />

        {/* DOT & Compliance Pages */}
        <Route path="/dot/dot-for-life" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-220">
              <Header data-id="element-221" />
              <main className="flex-grow" data-id="element-222">
                <DotForLifePage data-id="element-223" />
              </main>
              <Footer data-id="element-224" />
            </div>} data-id="element-219" />

        <Route path="/michigandotinspection.html" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-226">
              <Header data-id="element-227" />
              <main className="flex-grow" data-id="element-228">
                <MichiganDotInspectionPage data-id="element-229" />
              </main>
              <Footer data-id="element-230" />
            </div>} data-id="element-225" />

        <Route path="/dot/dot-inspection" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-232">
              <Header data-id="element-233" />
              <main className="flex-grow" data-id="element-234">
                <DotInspectionPage data-id="element-235" />
              </main>
              <Footer data-id="element-236" />
            </div>} data-id="element-231" />

        <Route path="/dot/dot-number" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-238">
              <Header data-id="element-239" />
              <main className="flex-grow" data-id="element-240">
                <DotNumberPage data-id="element-241" />
              </main>
              <Footer data-id="element-242" />
            </div>} data-id="element-237" />

        <Route path="/Cargo-Securement-Rules" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-244">
              <Header data-id="element-245" />
              <main className="flex-grow" data-id="element-246">
                <CargoSecurementRulesPage data-id="element-247" />
              </main>
              <Footer data-id="element-248" />
            </div>} data-id="element-243" />

        <Route path="/Vehicle-Inspection-Aid" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-250">
              <Header data-id="element-251" />
              <main className="flex-grow" data-id="element-252">
                <VehicleInspectionAidPage data-id="element-253" />
              </main>
              <Footer data-id="element-254" />
            </div>} data-id="element-249" />

        {/* CDL & Driver Resources Pages */}
        <Route path="/cdl/cdl-types" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-256">
              <Header data-id="element-257" />
              <main className="flex-grow" data-id="element-258">
                <CdlTypesPage data-id="element-259" />
              </main>
              <Footer data-id="element-260" />
            </div>} data-id="element-255" />

        <Route path="/cdl/cdl-do-i-need-one" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-262">
              <Header data-id="element-263" />
              <main className="flex-grow" data-id="element-264">
                <CdlDoINeedOnePage data-id="element-265" />
              </main>
              <Footer data-id="element-266" />
            </div>} data-id="element-261" />

        <Route path="/cdl/cdl-testing-info" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-268">
              <Header data-id="element-269" />
              <main className="flex-grow" data-id="element-270">
                <CdlTestingInfoPage data-id="element-271" />
              </main>
              <Footer data-id="element-272" />
            </div>} data-id="element-267" />

        <Route path="/cdl/hours-of-service" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-274">
              <Header data-id="element-275" />
              <main className="flex-grow" data-id="element-276">
                <HoursOfServicePage data-id="element-277" />
              </main>
              <Footer data-id="element-278" />
            </div>} data-id="element-273" />

        <Route path="/cdl/medical-card-info" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-280">
              <Header data-id="element-281" />
              <main className="flex-grow" data-id="element-282">
                <MedicalCardInfoPage data-id="element-283" />
              </main>
              <Footer data-id="element-284" />
            </div>} data-id="element-279" />

        <Route path="/cdl/gvw-page" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-286">
              <Header data-id="element-287" />
              <main className="flex-grow" data-id="element-288">
                <GvwPage data-id="element-289" />
              </main>
              <Footer data-id="element-290" />
            </div>} data-id="element-285" />

        <Route path="/cdl/vehicle-load-size" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-292">
              <Header data-id="element-293" />
              <main className="flex-grow" data-id="element-294">
                <VehicleLoadSizePage data-id="element-295" />
              </main>
              <Footer data-id="element-296" />
            </div>} data-id="element-291" />

        <Route path="/cdl/over-sized-load" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-298">
              <Header data-id="element-299" />
              <main className="flex-grow" data-id="element-300">
                <OverSizedLoadPage data-id="element-301" />
              </main>
              <Footer data-id="element-302" />
            </div>} data-id="element-297" />

        <Route path="/cdl/interstate-operating-authority" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-304">
              <Header data-id="element-305" />
              <main className="flex-grow" data-id="element-306">
                <InterstateOperatingAuthorityPage data-id="element-307" />
              </main>
              <Footer data-id="element-308" />
            </div>} data-id="element-303" />

        <Route path="/cdl/registration-licensing-forms" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-310">
              <Header data-id="element-311" />
              <main className="flex-grow" data-id="element-312">
                <RegistrationLicensingFormsPage data-id="element-313" />
              </main>
              <Footer data-id="element-314" />
            </div>} data-id="element-309" />

        <Route path="/cdl/traffic-violation-convictions" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-316">
              <Header data-id="element-317" />
              <main className="flex-grow" data-id="element-318">
                <TrafficViolationConvictionsPage data-id="element-319" />
              </main>
              <Footer data-id="element-320" />
            </div>} data-id="element-315" />

        <Route path="/cdl/what-else-do-i-need-to-know" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-322">
              <Header data-id="element-323" />
              <main className="flex-grow" data-id="element-324">
                <WhatElseDoINeedToKnowPage data-id="element-325" />
              </main>
              <Footer data-id="element-326" />
            </div>} data-id="element-321" />

        {/* Professional Services */}
        <Route path="/services/professional-witness" element={<div className="flex flex-col min-h-screen bg-white" data-id="element-328">
              <Header data-id="element-329" />
              <main className="flex-grow" data-id="element-330">
                <ProfessionalWitnessPage data-id="element-331" />
              </main>
              <Footer data-id="element-332" />
            </div>} data-id="element-327" />
      </Routes>
    </BrowserRouter>;
}